<template>
  <div>
    <nav
        class="mobile-filters" :class="{ active: isOpen }"
    >
      <div class="modal">
        <div class="top-menu-icons">
          <button class="back-link" @click="$emit('close')">
            <svg class="icon arrow" width="16" height="8" viewBox="0 0 16 8" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12.6123 4.74998H0V3.24998H12.6122L10.6431 1.08534L11.7526 0.0759583L14.8632 3.49532L15.3223 4.00001L14.8632 4.5047L11.7526 7.92405L10.6431 6.91468L12.6123 4.74998Z"
                    fill="currentColor"/>
            </svg>
            Filtre
          </button>

          <button v-if="anyFilterSet" class="style-label-underscore clear-filters" @click="$emit('clear')">
            Ryd filtre
          </button>
        </div>

        <div class="modal-tags">
          <div class="mobile-tags-wrapper" v-for="section in filters" :key="section.label">
            <button class="style-h3 mobile-tag-wrapper filter-headline" @click="toggleSection(section.label)">
              {{ section.label }}
              <span class="icon">
                <svg :class="{open: isSectionOpen(section.label)}" class="section-icon"
                     xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6.71094 18L14.7109 10L6.71094 2L5.29427 3.41667L11.8776 10L5.29427 16.5833L6.71094 18Z"
                        fill="currentColor"/>
                </svg>
              </span>
            </button>

            <div v-show="openSections.includes(section.label)"
                 v-for="option in section.options" :key="option"
                 class="mobile-tag-wrapper"
            >
              <label class="mobile-tag">
                <span>{{ option }}</span>
                <input
                    type="checkbox"
                    :value="option"
                    :checked="section.model.value.includes(option)"
                    @change="onCheckboxChange($event, section)"
                />
              </label>
            </div>
          </div>

          <div class="close-btn-wrapper">
            <button class="button-secondary close-btn total-results-mobile-btn" @click="$emit('close')">
              Vis {{ totalVisible !== totalResults ? totalVisible : totalVisible === 0 ? 0 : 'alle' }} resultater
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup>
import {ref} from 'vue';

const props = defineProps({
  filters: {type: Array, required: true},
  isOpen: {type: Boolean, required: true},
  totalVisible: {type: Number, required: true},
  totalResults: {type: Number, required: true},
  anyFilterSet: {type: Boolean, default: true},
});

const emit = defineEmits(['close', 'clear']);

const openSections = ref([]);

const toggleSection = (index) => {
  if (openSections.value.includes(index)) {
    openSections.value = openSections.value.filter(i => i !== index);
  } else {
    openSections.value.push(index);
  }
};

const isSectionOpen = (value) => openSections.value.includes(value);

function onCheckboxChange(event, section) {
  const val = event.target.value;
  const model = section.model;

  const selected = [...model.value];

  const index = selected.indexOf(val);

  if (event.target.checked && index === -1) {
    selected.push(val);
  } else if (!event.target.checked && index !== -1) {
    selected.splice(index, 1);
  }

  model.value = selected;
}

</script>
